<template>
	<div>
		<Breadcrumbs main="" title="getQuote.header"/>
		<!-- Container-fluid starts-->
		<div class="container-fluid search-page">
            <div id="quoteForm">
                <div class="col-sm-12 gradient-wy">
                    <!-- <div class="exchange-rate-display">
                        <h2>Current EUR to USD Rate:</h2>
                        <p v-if="rate">
                        1 EUR = <span class="rate-value">{{ rate }} USD</span>
                        </p>
                        <p v-else-if="loading">Loading real-time rate...</p>
                        <p v-else-if="error">Error fetching rate: {{ error }}</p>
                    </div> -->
                    <div class="d-flex flex-row justify-content-between">
                        <div class=" text-dark f-w-600 ml-3">
                            <h2 >{{ $t('getQuote.header') }}</h2>
                        </div>
                        <div class="col-sm-2">
                            <b-button style="font-size:20px;" size="md" variant="success" block @click="gotoCustBookingTx">
                                {{ $t('sidebar.eBooking') }}
                            </b-button>      
                        </div>                        
                    </div>
                    <form class="theme-form">
                        <div class=" mb-3 gradient-wb" >
                            <div class="row m-4"> 
                                <div class="col-sm-5 mb-3">
                                    <label for="commodity" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("getQuote.commodity") }}</label>                                                                       
                                    <b-form-input class="style-chooser" style="font-size:16px;" v-model="commodity" type = "text" :placeholder="$t('getQuote.commodityPh')">                            
                                    </b-form-input>
                                </div>   
                                <div class="col-sm-1 mt-1">
                                   <label for="dgGds" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{ $t('getQuote.dgGds') }}</label> 
                                   <div class="row mt-2 ml-1">
                                    <label class="switch">
                                        <input type="checkbox" v-model="dgGds">
                                        <span class="slider round"></span>
                                    </label>
                                    <span v-show="dgGds" class="ml-2 text-danger" style="font-size:16px;">{{  $t('getQuote.dg') }}</span>
                                   </div>
                                </div>                             
                                <div class="col-sm-3">
                                    <label for="hs6" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("hsCode.HS") }}</label>                                                                       
                                    <v-select 
                                        class="style-chooser" 
                                        style="font-size:16px;" 
                                        v-model="hs6" 
                                        :options="optionsHS6"
                                        :placeholder="$t('surcharge.plsSelect')"
                                    >                              
                                    </v-select>
                                </div>
                                <div class="col-sm-3 mt-4">
                                    <b-button 
                                        style="font-size:22px"
                                        @click="clickFindHS6"
                                        variant="primary"
                                        >{{ $t('getQuote.findHS6') }}
                                    </b-button>                                
                                </div>
                            </div>
                        </div>    
                        <div class="ml-1 mb-4 gradient-wb" >
                            <h5 class=" text-info f-w-600 ml-3" style="font-size: 14px;">{{ $t('getQuote.selectCont') }}</h5>
 
                            <div id="dynamic-form-app">
                                <div
                                    v-for="(selection, index) in sqwSelection"
                                    :key="selection.id"
                                    class="select-group"
                                >
                                    <label class="col-form-label pt-0 f-w-600 mt-2" style="font-size:16px;" :for="'select-' + selection.id">
                                        {{`${$t("seal.item")}#${index + 1}` }}:
                                    </label>
                                    <div class="col-sm-3 mb-4">
                                        <label v-show="index==0" for="contSize" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("require.contSize") }}</label>    
                                        <b-form-select
                                            :id="'select-' + selection.id"
                                            v-model="selection.contSize"
                                            style="font-size:18px;"
                                            :options="optionsContSize"
                                            :placeholder="$t('getQuote.contSizePh')"
                                        >
                                            <template #first>
                                                <b-form-select-option :value="''" disabled>{{ $t("surcharge.plsSelect") }}</b-form-select-option>
                                            </template>   
                                        </b-form-select>                                        
                                    </div>
                                    <div class="col-sm-3">
                                        <div role="group">
                                            <label v-show="index==0" for="contQty" class="col-form-label pt-0 f-w-600">{{$t("getQuote.contQty") }}</label>
                                            <b-form-input
                                                id="contQty"
                                                style="font-size:16px;" 
                                                v-model="selection.contQty"
                                                type="number"
                                                :state="contQtyState(index)"
                                                aria-describedby="input-live-help-contQty input-live-feedback-contQty"
                                                :placeholder="$t('getQuote.contQtyPh')"
                                                min="1" 
                                                max="100">
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-contQty"> {{ $t("getQuote.contQtyAllow") }}</b-form-invalid-feedback>
                                            <b-form-text id="input-live-help-contQty">{{ $t("getQuote.contQtyTotal") }}</b-form-text>           
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div role="group">
                                            <label v-show="index==0" for="cargoKg" class="col-form-label pt-0 f-w-600">{{$t("getQuote.cargoKg") }}</label>
                                            <b-form-input 
                                                id="cargoKg"
                                                style="font-size:16px;" 
                                                v-model="selection.cargoKg"  
                                                type="number" 
                                                :state="cargoKgState(index)"
                                                aria-describedby="input-live-help-cargoKg input-live-feedback-cargoKg"
                                                :placeholder="$t('getQuote.cargoKgPh')"
                                                min="100"
                                                max="30000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-cargoKg"> {{ $t("getQuote.cargoKgAllow") }}</b-form-invalid-feedback>
                                            <b-form-text id="input-live-help-cargoKg">{{ $t("getQuote.cargoKgWeight") }}</b-form-text>                                   
                                        </div>
                                    </div>
                                    <button
                                        @click="removeSelection(index)"
                                        type="button"
                                        class="remove-button"
                                    >
                                    {{ $t("getQuote.remove") }}
                                    </button>
                                </div>
                                <div class="row ml-5">
                                    <div class="ml-5">
                                        <b-button 
                                            @click="addSelection" 
                                            :disabled="sqwSelection.length >= 3" 
                                            size="lg" 
                                            variant="primary"
                                            style="font-size:22px;" 
                                            class="mx-4 mt-4" 
                                            v-b-popover.hover.bottom="$t('getQuote.detailsAddSQW')"
                                            
                                        >
                                        + {{ $t("getQuote.addSQW") }}
                                        </b-button>                                        
                                    </div>
                                    <div class="col-sm-3 ml-1">
                                        <label for="contType" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("require.contType") }}</label>                                                                       
                                        <b-form-select class="style-chooser" style="font-size:16px;" v-model="contType" :options="optionsContType" :placeholder="$t('getQuote.contTypePh')">                            
                                            <template #first>
                                                <b-form-select-option :value="''" disabled>{{ $t("surcharge.plsSelect") }}</b-form-select-option>
                                            </template>    
                                        </b-form-select>
                                    </div>
                                    <div class="col-sm-3 ">
                                        <label for="contGrade" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("require.contGrade") }}</label>                                                                       
                                        <b-form-select class="style-chooser" style="font-size:16px;" v-model="contGrade" :options="optionsContGrade" :placeholder="$t('getQuote.contGradePh')">                            
                                            <template #first>
                                                <b-form-select-option :value="''" disabled>{{ $t("surcharge.plsSelect") }}</b-form-select-option>
                                            </template>    
                                        </b-form-select>
                                    </div>
                                </div> 
                                <!-- <hr>
                                <h3>Current Data Output:</h3>
                                <pre>{{ sqwSelection }}</pre>
                                <hr> -->
                                <!-- <h3>Flattened Selected Values:</h3>
                                <p>{{ allSelectedValues }}</p> -->
                            </div>
                            <div class="row ml-1 mb-4">
                            </div>
                        </div>                                            
                        <div class="ml-1 mb-4 gradient-wb">
                            <h5 class=" text-info f-w-600 ml-3" style="font-size: 14px;">{{ $t('getQuote.inputRoute') }}</h5>
                            <div class="ml-3 mb-4">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label for="selectedPOL" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("getQuote.POL") }}</label>                                                                       
                                        <v-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedPOL"
                                            :reduce="text => text.value"
                                            label = 'text'
                                            :options="POLList" 
                                            :placeholder="$t('getQuote.POLPh')">                            
                                        </v-select>
                                    </div>
                                    <div class="col-sm-3">
                                        <label for="shipDateReqr" class="f-w-600 text-primary" style="font-size: 16px">{{ $t("getQuote.shipDateReqr") }}</label>
                                        <datepicker input-class="datepicker-here form-control digits"  :disabled-dates="disabledDates"  :format="format" v-model="shipDateReqr" ></datepicker>
                                    </div>  
                                </div>
                                <div class="row">
                                    <div class="col-sm-6 mb-3">
                                        <label for="selectedCntryPOD" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("getQuote.cntryPOD") }}</label>                                                                       
                                        <v-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedCntryPOD" 
                                            @input="trigPortListByCntry"  
                                            :reduce="text => text.value"
                                            label = 'text'
                                            :options="cntryList" 
                                            :placeholder="$t('getQuote.cntryPODPh')">                            
                                        </v-select>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <label for="selectedPOD" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("getQuote.POD") }}</label>  
                                        <v-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedPOD" 
                                            :reduce="text => text.value"
                                            label = 'text'
                                            :options="PODList" 
                                            :placeholder="$t('getQuote.PODPh')">    
                                        </v-select>
                                    </div>                                      
                                </div>
                            </div>   
                        </div>
                        <div class="d-flex flex-row justify-content-between mx-3 my-1">
                            <div class="col-sm-3 mt-4">
                                <button 
                                    class="btn btn-primary btn-block" 
                                    style="font-size:20px" type="button" 
                                    @click="handleProcess('quoteForm')"
                                    :disabled="this.selectedPOL == '' || this.selectedPOL == '' || this.showQuoteOptions"
                                    >{{ $t('getQuote.saveQuoteForm') }}
                                </button>
                            </div>
                            <div class="col-sm-3 mt-4">
                                <button 
                                    class="btn btn-warning btn-block" 
                                    style="font-size:20px" type="button" 
                                    @click="clearQuoteForm"
                                    :disabled=" this.showQuoteOptions"
                                    >{{ $t('getQuote.clearData') }}
                                </button>
                            </div>
                            <div class="col-sm-3 mt-4">
                                <button 
                                    class="btn btn-primary btn-block" 
                                    style="font-size:20px" type="button" 
                                    @click="handleProcess('getQuote')"
                                    :disabled="this.selectedPOL == '' || this.selectedPOL == '' || this.showQuoteOptions"
                                    >{{ $t('getQuote.getQuote') }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                <b-alert v-model="showAlertNoServicePOD" variant="warning" dismissible class="col-sm-6 mt-3 text-dark">
                    <div class="row ml-3">
                        <h4 class="alert-heading text-primary f-w-800">{{ $t("getQuote.noServicePOD")}} : </h4>
                        <span class="text-dark f-w-800 mx-2" style="font-size: 20px;">{{ this.selectedPOD}}</span>
                    </div>
                    <div class="row ml-3">
                        <h4 class="text-primary f-w-800"> {{ $t("getQuote.plsSelOtherPOD")}}</h4>
                    </div>
                </b-alert>
                <div class="divider"> </div> 
                <div v-show="!showQuoteOptions">
                    <h2 class="ml-4 mt-3 f-w-600">{{ $t('getQuote.quoteHistList') }}</h2>               
                    <div class="row mt-3">    
                        <b-col lg="4">
                            <b-form-group
                            :label="$t('matchTx.filter')"
                            label-for="filter-input"
                            label-cols-sm="3"
                            label-align-sm="right"
                            label-size="lg"
                            class="mb-0"
                            >
                            <b-input-group size="sm">
                                <b-form-input
                                id="filter-input"
                                v-model="filter"
                                type="search"
                                :placeholder="$t('matchTx.typeToSearch')"
                                class="text-info"
                                style="font-size: 18px;"
                                ></b-form-input>
                                <b-input-group-append>
                                <b-button size="md" variant="primary" :disabled="!filter" @click="filter = ''">
                                    {{ $t('matchTx.clear') }}
                                </b-button>
                                </b-input-group-append>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col lg="6" >
                            <b-form-group
                            v-model="sortDirection"
                            :label="$t('matchTx.filterOn')"
                            :description= "$t('matchTx.uncheck')"
                            label-cols-sm="3"
                            label-align-sm="right"
                            label-size="lg"
                            class="mb-0"
                            v-slot="{ ariaDescribedby }"
                            >
                            <b-form-checkbox-group
                                v-model="filterOn"
                                :aria-describedby="ariaDescribedby"
                                class="text-info"
                                plain
                            > 
                                <b-form-checkbox value="commodity">{{ $t('getQuote.commodity') }}</b-form-checkbox>
                                <b-form-checkbox value="POL">{{ $t('getQuote.POL') }}</b-form-checkbox>         
                                <b-form-checkbox value="POD">{{ $t('getQuote.POD') }}</b-form-checkbox>     
                                <b-form-checkbox value="cntryPOD">{{ $t('getQuote.cntryPOD') }}</b-form-checkbox>     
                            </b-form-checkbox-group>
                            </b-form-group>
                        </b-col>   
                    </div>
                    <b-table
                        sticky-header
                        head-variant="light"
                        table-variant="white"
                        bordered
                        show-empty
                        sort-icon-left
                        stacked="md"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync= "sortDesc"
                        :sort-direction="sortDirection"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        :items="items"
                        :fields="fields"
                        :current-page="currentPage"
                        :per-page="perPage"
                        @filtered="onFiltered"
                    >
                        <!-- A virtual column -->
                        <template #cell(index)="data">
                            {{ data.index + 1 }}
                        </template>
                        <template #cell(contSQWArr)="row" >
                            <div
                                v-for="(sqw, index) in row.item.contSQW"
                                :key="index"
                                class="select-group-sqw"
                            >
                                <span class="ml-2"># {{index + 1}}:</span>         
                                <span class="ml-2">{{ sqw.contSize}} - </span>       
                                <span>{{ sqw.contQty}} - </span>      
                                <span>{{ sqw.cargoKg}} </span>      
                            </div>
                        </template>
                        <template #cell(detailsPOL)="row" >
                            <b-button size="sm" @click="openModalDetailsPOL(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('freight.detailsPort')">
                                {{ row.item.POL}}
                            </b-button>
                        </template>
                        <template #cell(detailsPOD)="row" >
                            <b-button size="sm" @click="openModalDetailsPOD(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('freight.detailsPort')">
                                {{ row.item.POD}}
                            </b-button>
                        </template>
                        <template #cell(actions)="row" >
                            <b-button pill size="sm" @click="actUseAgain(row.item)" href="#quoteForm" class="m-1 btn-success">
                            <span class="f-w-600" style="font-size: 16px;"> {{ $t('getQuote.useAgain') }}</span>
                            </b-button>
                            <b-button pill size="sm" @click="actDelete(row.item)" class="m-1 btn-danger">
                                <span class="f-w-600" style="font-size: 16px;"> {{ $t('container.delete') }}</span>
                            </b-button>                        
                        </template>
                        <template #empty>
                            <h3 class="text-primary">{{ $t('getQuote.noRecordQuoteForm') }}</h3>
                        </template>
                    </b-table>
                    <b-row>
                        <div class="row col-sm-8 ">
                        <b-col class="my-1 ml-3">
                            <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            class="my-0"
                            ></b-pagination>
                        </b-col>   
                        <b-col sm="3" md="6" class="my-1">
                            <b-form-group
                            :label= "$t('require.perPage')"
                            label-for="per-page-select"
                            label-cols-sm="6"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label-align-sm="right"
                            label-size="sm"
                            class="mb-0"
                            >
                            <b-form-select
                                id="per-page-select"
                                v-model="perPage"
                                :options="pageOptions"
                            ></b-form-select>
                            </b-form-group>
                        </b-col>
                        </div>
                    </b-row>                
                </div>                   

                <div v-show="showQuoteOptions" v-b-popover.hover.top="$t('getQuote.clickQuoteSelection')" > 
                    <span class="ml-4 mt-3 f-w-600 text-primary" style="font-size: 22px;">{{ $t('getQuote.quoteOptions') }}</span>               
                    <span class="ml-4 mt-3 f-w-600 text-info" style="font-size: 16px;">{{ $t('getQuote.quoteOptionsMsg') }}</span>  
                    <div class="row mt-3">    
                        <b-col lg="4">
                            <b-form-group
                            :label="$t('matchTx.filter')"
                            label-for="filter-input"
                            label-cols-sm="3"
                            label-align-sm="right"
                            label-size="lg"
                            class="mb-0"
                            >
                            <b-input-group size="sm">
                                <b-form-input
                                id="filter-input"
                                v-model="filterQO"
                                type="search"
                                :placeholder="$t('matchTx.typeToSearch')"
                                class="text-info"
                                style="font-size: 18px;"
                                ></b-form-input>
                                <b-input-group-append>
                                <b-button size="md" variant="primary" :disabled="!filterQO" @click="filterQO = ''">
                                    {{ $t('matchTx.clear') }}
                                </b-button>
                                </b-input-group-append>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col lg="5" >
                            <b-form-group
                            v-model="sortDirectionQO"
                            :label="$t('matchTx.filterOn')"
                            :description= "$t('matchTx.uncheck')"
                            label-cols-sm="3"
                            label-align-sm="right"
                            label-size="lg"
                            class="mb-0"
                            v-slot="{ ariaDescribedby }"
                            >
                            <b-form-checkbox-group
                                v-model="filterOnQO"
                                :aria-describedby="ariaDescribedby"
                                class="text-info"
                                plain
                            > 
                                <b-form-checkbox value="agent">{{ $t('matchTx.agent') }}</b-form-checkbox>
                                <b-form-checkbox value="fghtCat">{{ $t('freight.cat') }}</b-form-checkbox>                                 
                                <b-form-checkbox value="POL">{{ $t('getQuote.POL') }}</b-form-checkbox>         
                                <b-form-checkbox value="POD">{{ $t('getQuote.POD') }}</b-form-checkbox>     
                            </b-form-checkbox-group>
                            </b-form-group>
                        </b-col>   
                    </div>
                    <b-table
                        selectable
                        select-mode="multi"
                        sticky-header
                        head-variant="light"
                        table-variant="success"
                        bordered
                        show-empty
                        sort-icon-left
                        stacked="md"
                        selectedVariant="primary"
                        :sort-by.sync="sortByQO"
                        :sort-desc.sync= "sortDescQO"
                        :sort-direction="sortDirectionQO"
                        :filter="filterQO"
                        :filter-included-fields="filterOnQO"
                        :items="itemsQO"
                        :fields="fieldsQO"
                        :current-page="currentPageQO"
                        :per-page="perPageQO"
                        @filtered="onFilteredQO"
                        @row-selected="rowSelected"
                    >
                        <template #cell(index)="data">
                            {{ data.index + 1 }}
                        </template>
                        <template #cell(detailsPOL)="row" >
                            <b-button size="sm" @click="openModalDetailsPOL(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('freight.detailsPort')">
                                {{ row.item.POL}}
                            </b-button>
                        </template>
                        <template #cell(detailsPOD)="row" >
                            <b-button size="sm" @click="openModalDetailsPOD(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('freight.detailsPort')">
                                {{ row.item.POD}}
                            </b-button>
                        </template>
                        <template #cell(detailsFght)="row" >
                            <b-button size="sm" @click="openModalDetailsFght(row.item, row.index, $event.target )" style="font-size:16px" variant="outline-dark" v-b-popover.hover.top="$t('getQuote.detailsFght')">
                                {{ row.item.fUSD.toFixed(0)}}
                            </b-button>
                        </template>
                        <template #cell(detailsSur)="row" >
                            <b-button size="sm" @click="openModalDetailsSur(row.item, row.index, $event.target )" style="font-size:16px" variant="outline-dark" v-b-popover.hover.top="$t('getQuote.detailsSur')">
                                {{ row.item.surUSD.toFixed(0)}}
                            </b-button>
                        </template>
                        <template #empty>
                            <h3 class="text-primary">{{ $t('getQuote.noRecordQO') }}</h3>
                        </template>
                    </b-table>
                    <b-row>
                        <div class="row col-sm-6">
                            <div class="col-sm-6 ">
                                <b-col class="my-1 ml-3">
                                    <b-pagination
                                    v-model="currentPageQO"
                                    :total-rows="totalRowsQO"
                                    :per-page="perPageQO"
                                    class="my-0"
                                    ></b-pagination>
                                </b-col>   
                            </div>
                            <div class="col-sm-5 mr-5 " >
                                <b-form-group label-cols="2" :label= "$t('require.perPage')" class="datatable-select">
                                <b-form-select v-model="perPageQO" :options="pageOptionsQO"></b-form-select>
                                </b-form-group>
                            </div>                              
                        </div>
                        <div class="row col-sm-5" >  
                            <b-col lg="2" >
                                <b-button variant="danger" @click="clickCancelQO" class="mx-1" style="font-size:20px" >
                                    {{ $t('matchTx.cancel') }}
                                </b-button>                                
                            </b-col>
                            <b-col class="ml-5">
                                <b-button :disabled = "selectedQO.length == 0 ? true : false" variant="primary" @click="selectBatchRowQO" class="mx-1" style="font-size:20px">
                                    {{ $t("release.confirmSelected") }} <span class="position-absolute top-0 start-100 translate-middle badge rouned-pill bg-warning">{{ selectedQO.length }}</span>   
                                </b-button>
                            </b-col>                                             
                        </div>   
                    </b-row>
                </div>                    
            </div>
            <b-modal id="detailsPortModal" :title="$t('freight.detailsPort')" size="md" ok-only @hide="resetModalDetailsPort">
                <div class="row ml-2">
                    <h3 class="mt-3"> {{ $t('port.portId') }} :</h3>
                    <h3 class="mt-3 ml-2 text-info"> {{this.portId }}</h3>
                </div>   
                <div class="row ml-2">
                    <h3 class="mt-3"> {{ $t('port.pName') }} :</h3>
                    <h3 class="mt-3 ml-2 text-info"> {{this.pName }}</h3>
                </div>                
                <div class="row ml-2">
                    <h3 class="mt-3"> {{ $t('port.cntry') }} :</h3>
                    <h3 class="mt-3 ml-2 text-info"> {{ this.cntry }}</h3>
                </div>
            </b-modal>
            <b-modal id="detailsFghtModal" :title="$t('getQuote.detailsFght')" size="lg" ok-only @hide="resetModalDetailsFght">
                <b-table
                    sticky-header
                    head-variant="dark"
                    show-empty
                    bordered
                    responsive
                    sort-icon-left
                    stacked="md"
                    :items="itemsFght"
                    :fields="fieldsFght"
                >
                    <template #empty>
                        <h5>{{ $t('reuse.noRecord') }}</h5>
                    </template>
                </b-table>
            </b-modal>
            <b-modal id="detailsSurModal" :title="$t('getQuote.detailsSur')" size="lg" ok-only @hide="resetModalDetailsFght">
                <b-table
                    sticky-header
                    head-variant="dark"
                    show-empty
                    bordered
                    responsive
                    sort-icon-left
                    stacked="md"
                    :items="itemsSur"
                    :fields="fieldsSur"
                >
                    <template #empty>
                        <h5>{{ $t('reuse.noRecord') }}</h5>
                    </template>
                    <template #cell(detailsSurCode)="row" >
                        <b-button size="sm" @click="openModalDetailsSurCode(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('surcharge.detailsSurCode')">
                            {{ row.item.surCode}}
                        </b-button>
                    </template>
                </b-table>
            </b-modal>
            <b-modal id="detailsSurCodeModal" :title="$t('surcharge.detailsSurCode')" size="md" ok-only @hide="resetModalDetailsSurCode">
                <div class="row ml-2">
                    <h3 class="mt-3"> {{ $t('surcharge.surCode') }} :</h3>
                    <h3 class="mt-3 ml-2 text-info"> {{this.selectedSurCode }}</h3>
                </div>   
                <div class="row ml-2">
                    <h3 class="mt-3"> {{ $t('surcharge.surDesc') }} :</h3>
                    <h3 class="mt-3 ml-2 text-info"> {{this.surDesc }}</h3>
                </div>                
                <div class="row ml-2">
                    <h3 class="mt-3"> {{ $t('slip.remark') }} :</h3>
                    <h3 class="mt-3 ml-2 text-info"> {{ this.remark}}</h3>
                </div>
            </b-modal>
            <b-modal id="restPOLsModal" :title="$t('getQuote.noSelPOL')" size="md" hide-footer @hide="resetModalRestPOL">
                <div class="col-sm-12">
                    <b-form-group class="f-w-600" style="font-size: 20px"  :label="$t('getQuote.canSelRestPOLs')" v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                            v-model="selectedRestPOL"
                            :options="restPOLsOptions"
                            :aria-describedby="ariaDescribedby"
                            plain
                            stacked
                            size="lg"
                        ></b-form-radio-group>
                    </b-form-group>
                    <div class="row col-sm-12 ">
                        <div class="col-sm-4 m-4">
                            <button class="btn btn-primary btn-block" style="font-size:20px"  type="button" @click="clickUpdateSelRestPOLs">{{ $t('truck.ok') }}</button>
                        </div>
                        <div class="col-sm-4 m-4">
                            <button class="btn btn-danger btn-block" style="font-size:20px"  type="button" @click="clickCancelRestPOLs">{{ $t('matchTx.cancel') }}</button>
                        </div>                         
                    </div>
                </div>  
            </b-modal>
            <b-modal id="addInfoModal" hide-footer variant="info" size="lg" :title="$t('getQuote.addInfo')" @hide="resetModalAddInfo">
                <h4 class="text-primary mx-3">{{ $t('getQuote.addInfoMsg') }}</h4>
                <div class="col-sm-12 gradient-wg" role="group">
                    <label for="shipper" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("getQuote.shipper") }}</label>
                    <b-form-input
                        id="shipper"
                        style="font-size:16px;" 
                        v-model="shipper"
                        type="text"
                        :formatter="formatter"
                        aria-describedby="input-live-help-shipper"
                        :placeholder="$t('getQuote.shipperPh')"
                    >
                    </b-form-input>
                    <b-form-text id="input-live-help-shipper">{{ $t("getQuote.shipperHelp") }}</b-form-text>           
                </div>  
                <div class="col-sm-12 gradient-wy" role="group">
                    <label for="forwarder" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("getQuote.forwarder") }}</label>
                    <b-form-input
                        id="forwarder"
                        style="font-size:16px;" 
                        v-model="forwarder"
                        type="text"
                        :formatter="formatter"
                        aria-describedby="input-live-help-forwarder"
                        :placeholder="$t('getQuote.forwarderPh')"
                    >
                    </b-form-input>
                    <b-form-text id="input-live-help-forwarder">{{ $t("getQuote.forwarderHelp") }}</b-form-text>           
                </div>  
                <div class="col-sm-12 gradient-wg" role="group">
                    <label for="cargoOwner" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("getQuote.cargoOwner") }}</label>
                    <b-form-input
                        id="cargoOwner"
                        style="font-size:16px;" 
                        v-model="cargoOwner"
                        type="text"
                        :formatter="formatter"
                        aria-describedby="input-live-help-cargoOwner"
                        :placeholder="$t('getQuote.cargoOwnerPh')"
                    >
                    </b-form-input>
                    <b-form-text id="input-live-help-cargoOwner">{{ $t("getQuote.cargoOwnerHelp") }}</b-form-text>           
                </div> 
                <div class="col-sm-12 gradient-wy" role="group">
                    <label for="POR" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("getQuote.POR") }}</label>
                    <b-form-input
                        id="POR"
                        style="font-size:16px;" 
                        v-model="POR"
                        type="text"
                        :formatter="formatter"
                        aria-describedby="input-live-help-POR"
                        :placeholder="$t('getQuote.PORPh')"
                    >
                    </b-form-input>
                    <b-form-text id="input-live-help-POR">{{ $t("getQuote.PORHelp") }}</b-form-text>           
                </div> 
                <div class="col-sm-12 gradient-wg" role="group">
                    <label for="DEL" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("getQuote.DEL") }}</label>
                    <b-form-input
                        id="DEL"
                        style="font-size:16px;" 
                        v-model="DEL"
                        type="text"
                        :formatter="formatter"
                        aria-describedby="input-live-help-DEL"
                        :placeholder="$t('getQuote.DELPh')"
                    >
                    </b-form-input>
                    <b-form-text id="input-live-help-DEL">{{ $t("getQuote.DELHelp") }}</b-form-text>           
                </div> 
                <div class="row col-sm-12  my-2 mx-2">
                    <div class="col-sm-4 m-4">
                        <b-button class="mx-2" style="font-size:18px;" variant="warning" block @click="clickCancelGetQuote">
                            {{ $t('matchTx.cancel') }}
                        </b-button>  
                    </div>
                    <div class="col-sm-4 m-4">
                        <b-button class="mx-2" style="font-size:18px;" variant="primary" block @click="saveBookingTx">
                            {{ $t('truck.ok') }}
                        </b-button>      
                    </div>
                    <!-- <div class="col-sm-4 m-4">
                        <b-button class="mx-2" style="font-size:18px;" variant="success" block @click="saveBookingTx('custBooking')">
                            {{ $t('getQuote.okCustBooking') }}
                        </b-button>      
                    </div> -->
                </div>
            </b-modal>       
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
<script>
// A simple counter to ensure unique IDs for each dynamic input
let nextSelectionId = 1;
import { cvf2USD, getData, getPortNameCode, getPortList, saveWithId, deleteItem,getCntryList, getHS6List, getFghtRateByPOD, getPortListByPortArr, getSrvScpArrByCntry, getSurchargeByArrs} from "../../firebase"
import {contSize, contType ,contGrade, teuCont} from '../../constants/config'
import { axiosExchange} from "../../utilities/axiosComp" 
export default {
	data(){
		return{
            exchangeRate: '',
            sqwSelection: [
            { id: nextSelectionId++, contSize: '', contQty: 1, cargoKg: 100 } // Start with one select item
            ],
            compId : '',
            userId : '',
            showQuoteOptions: false,
            showAlertNoServicePOD : false,
            selectedRestPOL : '',
            restPOLsOptions : [],
            commodity : '',
            dgGds : false,            
            hs6: '',
            contType: '',
            contGrade: '', 
            selectedPOL : '',
            shipDateReqr : '',            
            selectedCntryPOD : '',
            selectedPOD : '',     
            optionsHS6 : [],                   
            optionsContType : contType,
            optionsContSize : contSize,
            optionsContGrade : contGrade, 
            POLList : [],            
            cntryList : [],
            PODList : [],
            portId : '',
            pName : '',
            cntry : '',
            shipper : '',
            forwarder : '',
            cargoOwner : '',
            POR: "",
            DEL : "",
            format: "yyyy-MM-dd",
            disabledDates: {
                to: new Date(Date.parse(new Date())+86400000),
            },
            compId: '',
            selectedSurCode : '',
            surDesc : '',
            remark : '',
            items: [],
            fields: [
                { key: 'index', label: this.$t('seal.item'), sortable: true , variant: 'info'},                      
                { key: 'qfId', label: this.$t('getQuote.qfId'), sortable: true, variant: 'info'},  
                { key: 'commodity', label: this.$t('getQuote.commodity'), sortable: true , variant: 'info'},  
                { key: 'dgGDs', label: this.$t('getQuote.dgGds'), variant: 'info',
                    formatter: value => {
                        return this.$t(`getQuote.${value}`)
                }},     
                { key: 'hs6', label: this.$t('hsCode.HS'), sortable: true , variant: 'info'}, 
                { key: 'contSQWArr', label: this.$t('getQuote.contSQW'), sortable: true, variant: 'primary' },
                { key: 'contType', label: this.$t('matchTx.contType'), sortable: true , variant: 'primary',                     
                    formatter: value => {
                        return value.toUpperCase()
                }}, 
                { key: 'contGrade', label: this.$t('matchTx.gradeTh'), sortable: true, variant: 'primary' },                
                { key: 'sdrTS', label: this.$t('getQuote.shipDateReqr'), sortable: true , variant: 'info', 
                    formatter: value => {
                        return this.$moment(value).format("YYYY-MM-DD")
                }},                                                      
                { key: 'detailsPOL', label: this.$t('getQuote.POL'), sortable: true , variant: 'info'},  
                { key: 'detailsPOD', label: this.$t('getQuote.POD'), sortable: true , variant: 'info'}, 
                // { key: 'cntryPOD', label: this.$t('getQuote.cntryPOD'), sortable: true,  variant: 'info'},
                { key: 'actions', label: this.$t('matchTx.actions'), variant: 'warning'},
                { key: 'ts', label: this.$t('driver.recordAt'), sortable: true , variant: 'info', 
                    formatter: value => {
                        return this.$moment(value).format("YYYY-MM-DD")
                }}, 
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
            sortBy: 'ts',
            sortDesc: true,
            sortDirection: 'desc',
            filter: null,
            filterOn: [],
            itemsFght : [],
            fieldsFght: [
                { key: 'contSize', label: this.$t('container.contSize'), sortable: true , variant: 'info'},                                                 
                { key: 'contQty', label: this.$t('getQuote.contQty'), sortable: true , variant: 'info'},  
                { key: 'fRate', label: this.$t('freight.fghtRate'), sortable: true , variant: 'info'}, 
                { key: 'fCurr', label: this.$t('freight.currency'), sortable: true, variant: 'primary' },  
                { key: 'fCalc', label: this.$t('freight.amount'), sortable: true, variant: 'primary' },  
                { key: 'fUSD', label: this.$t('freight.USD'), sortable: true, variant: 'warning' },  
                { key: 'cargoKg', label: this.$t('getQuote.cargoKg'), sortable: true , variant: 'info'},  
            ],
            itemsSur : [],
            fieldsSur : [
                { key: 'detailsSurCode', label: this.$t('surcharge.surCode'), sortable: true , variant: 'info'},
                { key: 'agent', label: this.$t('matchTx.agent'), sortable: true, variant: 'primary' },   
                { key: 'rateBase', label: this.$t('surcharge.rateBase'), variant: 'primary' },        
                { key: 'sCurr', label: this.$t('freight.currency'), variant: 'primary' },    
                { key: 'surCalc', label: this.$t('freight.amount'), variant: 'primary' },    
                { key: 'surUSD', label: this.$t('freight.USD'), variant: 'warning' },  
                { key: 'surRate', label: this.$t('surcharge.surRate'), sortable: true , variant: 'secondary',
                    formatter: value => {
                        return parseInt(value) == 0 ? "N/A" : value
                }}, 
                { key: 'L20', label: this.$t('freight.L20'), sortable: true , variant: 'secondary',
                    formatter: value => {
                        return parseInt(value) == 0 ? "N/A" : value
                    }
                }, 
                { key: 'L40', label: this.$t('freight.L40'), sortable: true , variant: 'secondary',
                    formatter: value => {
                        return parseInt(value) == 0 ? "N/A" : value
                }}, 
                { key: 'L40HC', label: this.$t('freight.L40HC'), sortable: true , variant: 'secondary',
                    formatter: value => {
                        return parseInt(value) == 0 ? "N/A" : value
                }}, 
            ],
            itemsQO: [],
            fieldsQO: [
                { key: 'index', label: this.$t('seal.item'), sortable: true , variant: 'primary'},                      
                { key: 'agent', label: this.$t('matchTx.agent'), sortable: true, variant: 'info' },                
                { key: 'fghtCat', label: this.$t('freight.fghtCat'), sortable: true , variant: 'info',},       
                { key: 'sctCode', label: this.$t('freight.sctCode'), sortable: true , variant: 'info',},                             
                { key: 'detailsPOL', label: this.$t('getQuote.POL'), sortable: true , variant: 'info'},  
                { key: 'detailsPOD', label: this.$t('getQuote.POD'), sortable: true , variant: 'info'}, 
                { key: 'curr', label: this.$t('freight.currency'), sortable: true, variant: 'info' },        
                { key: 'detailsFght', label: this.$t('freight.header'), sortable: true , variant: 'warning'},  
                { key: 'detailsSur', label: this.$t('surcharge.header'), sortable: true , variant: 'warning'}, 
            ],
            totalRowsQO: 1,
            currentPageQO: 1,
            perPageQO: 10,
            pageOptionsQO: [5, 10, 15, { value: 100, text: "Show a lot" }],
            selectedQO: [],
            sortByQO: 'agent',
            sortDescQO: true,
            sortDirectionQO: 'asc',
            filterQO: null,
            filterOnQO: [],
		}
	},
	mounted(){
        this.compId = localStorage.getItem("compId")
        this.userId= localStorage.getItem("userId")     
        getPortList( "TH", (res)=>{
            this.POLList = res
        })
        
        getCntryList((res)=>{
            this.cntryList = res
        })
        
        getHS6List(async(res)=>{
            this.optionsHS6 = res
        })
        getData('QuoteForm', 'userId', this.userId,(res)=>{
            this.items = res 
            this.totalRows = res.length
        })
        this.getExchangeUSD()
        // this.fetchExchangeRate();
        // Optional: Set up a timer to refresh the rate every 60 seconds (for "real-time" feel)
        // this.interval = setInterval(this.fetchExchangeRate, 60000);
	},
    // beforeDestroy() {
    //     clearInterval(this.interval);
    // }
    computed: {
            // A computed property to gather all selected values into a single array
            // allSelectedValues() {
            // return this.sqwSelection.flatMap(selection => selection.selectedItems);
            // },

        sortOptions() {
            return this.fields
            .filter(f => f.sortable)
            .map(f => {
                return { text: f.label, value: f.key }
            })
        },
        sortOptionsQO() {
            return this.fieldsQO
            .filter(f => f.sortable)
            .map(f => {
                return { text: f.label, value: f.key }
            })
        },
    },
	methods:{
        async getExchangeUSD(){
            let late24Hrs_sec = Date.parse( new Date())/1000 - 86400
            await getData('ExchangeRate', 'source', 'USD', async(res)=>{
                if (res.length == 0) {// defualt for start up.
                  await this.fetchExchange()
                } else {
                    if (res[0].timestamp < late24Hrs_sec) {
                        await this.fetchExchange()
                    } else {
                        this.exchangeRate = res[0]
                        console.log( `exchangeRateFB => ${JSON.stringify(this.exchangeRate, null , 2)}`)
                    }
                }
            })
        },
        async fetchExchange(){
            axiosExchange( async(res)=>{
                if (res.resp == 'err') {
                    await getData('ExchangeRate', 'source', 'USD', async(exstRate)=>{
                    this.exchangeRate = exstRate[0]
                })
                } else {
                    let payload = {
                    success : res.data.success,
                    timestamp : res.data.timestamp,
                    source : res.data.source,
                    EUR : res.data.quotes.USDEUR,
                    JPY : res.data.quotes.USDJPY,
                    GBP : res.data.quotes.USDGBP,
                    CNY : res.data.quotes.USDCNY,
                    AUD : res.data.quotes.USDAUD,
                    CAD : res.data.quotes.USDCAD,
                    THB : res.data.quotes.USDTHB,
                }
                if (res.data.success) {
                    try { 
                        await saveWithId("ExchangeRate", res.data.source, payload).then(()=>{
                            this.exchangeRate = payload
                            // console.log( `exchangeRate,payload => ${JSON.stringify(payload, null , 2)}`)
                        })
                    } catch (error) {
                        this.$toasted.show(`Error while saving Exchange Rate: ' + ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
                    }
                }  
                }
            })
        },
        formatter(value) {
            return value.toUpperCase()
        },
        contQtyState(index) {
            return this.sqwSelection[index].contQty < 1 ? false : this.sqwSelection[index].contQty <= 100 ? true : false
        }, 
        cargoKgState(index) {
            return this.sqwSelection[index].cargoKg < 100 ? false :this.sqwSelection[index].cargoKg <= 30000 ? true : false
        },    
        /**
         * Adds a new object to the sqwSelection array,
         * which in turn renders a new select input via v-for.
         */
        addSelection() {
        this.sqwSelection.push({
            id: nextSelectionId++, // Ensure a unique key for v-for
            // Initialize with no selected items
            contSize: '',
            contQty : 1,
            cargoKg : 100 
        });
        },
        /**
         * Removes an object from the sqwSelection array by its index.
         * @param {number} index - The index of the item to remove.
         */
        removeSelection(index) {
        // Use Vue's reactive Array.prototype.splice() method
        this.sqwSelection.splice(index, 1);
        },
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },   
        onFilteredQO(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRowsQO = filteredItems.length
            this.currentPageQO = 1
        },      
        clickFindHS6(){
            // window.location.href='/info/hsCode'                     
            this.$router.push('/info/hsCode')
        },
        clickCancelQO(){              
            this.showQuoteOptions = false
            this.itemsQO = []
            this.totalRowsQO = 0
            this.clearQuoteForm()
        },
        async trigPortListByCntry( value){
            if (value) {
                this.selectedPOD = ''
                await getPortList(value, async(res)=>{
                    this.PODList = res
                })
            } 
            // else {
            //     this.$toasted.show(this.$t('getQuote.addCntryPOD'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000}); 
            // }
        },
        async handleProcess(process){
            let msg = 'completed'
            if (this.commodity ==='') {
                msg = 'getQuote.commodityPh'
            } else if (this.hs6 ===''){
                msg = 'getQuote.addHS6'
            } else if (this.sqwSelection[0].contSize ===''){
                msg = 'getQuote.selContSize1'
            } else if (this.sqwSelection[0].contQty < 1 || this.sqwSelection[0].contQty == null ){
                msg = 'getQuote.addContQty1'
            } else if (this.sqwSelection[0].cargoKg < 100 || this.sqwSelection[0].cargoKg == null){
                msg = 'getQuote.addCargoKg1'
            } else if (this.contType ===''){
                msg = 'container.selContType'
            } else if (this.contGrade ===''){
                msg = 'container.selContGrade'
            } else if (this.selectedPOL== ''){
                msg = 'getQuote.POLPh'
            } else if (this.shipDateReqr== ''){
                msg = 'getQuote.addShipDateReqr'
            } else if (this.selectedPOD== ''){
                msg = 'getQuote.PODPh'
            } else if (this.sqwSelection.length == 2 ){
                if (this.sqwSelection[1].contSize ===''){
                msg = 'getQuote.selContSize2'
                } else if (this.sqwSelection[0].contSize === this.sqwSelection[1].contSize){
                    msg = 'getQuote.repeatContSize'                
                } else if (this.sqwSelection[1].contQty < 1 || this.sqwSelection[1].contQty == null ){
                    msg = 'getQuote.addContQty2'
                } else if (this.sqwSelection[1].cargoKg < 100 || this.sqwSelection[1].cargoKg == null ){
                    msg = 'getQuote.addCargoKg2'
                } 
            } 
            else if (this.sqwSelection.length == 3 ){
                if (this.sqwSelection[2].contSize ===''){
                msg = 'getQuote.selContSize3'
                } else if (this.sqwSelection[0].contSize === this.sqwSelection[1].contSize || this.sqwSelection[0].contSize === this.sqwSelection[2].contSize || this.sqwSelection[1].contSize === this.sqwSelection[2].contSize){
                    msg = 'getQuote.repeatContSize'
                } else if (this.sqwSelection[2].contQty < 1 || this.sqwSelection[2].contQty == null ){
                    msg = 'getQuote.addContQty3'
                } else if (this.sqwSelection[2].cargoKg < 100 || this.sqwSelection[2].cargoKg == null){
                    msg = 'getQuote.addCargoKg3'
                } 
            } 
            if (msg === 'completed'){
                if (process == 'quoteForm') {
                    this.saveQuoteForm()   
                } else {
                    await this.duoCharges() 
                }                            
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }  
        },
        async saveQuoteForm(){
            let quoteFormId = this.$moment().format("YYMMDD")+'QF'+`${Math.floor(Math.random() * (90000 - 10000 + 1) + 10000)}`
            let payload = {
                qfId : quoteFormId,
                qCompId: this.compId,
                userId: this.userId,  
                commodity : this.commodity,
                dgGDs : this.dgGds,                       
                hs6 : this.hs6,      
                contType: this.contType,
                contGrade: this.contGrade,  
                contSQW : this.sqwSelection,
                POL : this.selectedPOL,
                sdrTS : Date.parse(this.shipDateReqr),                    
                cntryPOD : this.selectedCntryPOD,
                POD :this.selectedPOD,
                ts: Date.parse(new Date()),
            }
            // console.log ('payload=>'+JSON.stringify(payload , null, 2))
            await saveWithId('QuoteForm', quoteFormId, payload).then(async()=>{
                await this.refresh()
                this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                                                    
            })
            // })                
        },    
        async fghtSum(fr , cb){
            let frSum = []
            for (let rI = 0; rI < fr.length; rI++) {
                let sqwSel = this.sqwSelection
                let sqwItems=[]
                let fUSDSum = 0
                for (let sqwI = 0; sqwI < sqwSel.length; sqwI++) {
                    let fRate = 0
                    switch (sqwSel[sqwI].contSize) {
                        case 'L20':
                            fRate = parseInt(fr[rI].L20)
                            break;
                        case 'L40':
                            fRate = parseInt(fr[rI].L40)
                            break;
                        case 'L40HC':
                            fRate = parseInt(fr[rI].L40HC)
                            break;
                        case 'L20NOR':
                            fRate = parseInt(fr[rI].L20NOR)
                            break;
                        case 'L40NOR':
                            fRate = parseInt(fr[rI].L40NOR)
                            break;
                        case 'L40HR':
                            fRate = parseInt(fr[rI].L40HR)
                            break;
                            case 'L45':
                            fRate = parseInt(fr[rI].L45)
                            break;
                        case 'L45HC':
                            fRate = parseInt(fr[rI].L45HC)
                            break;
                        default:
                            break;
                    }
                    let contQty = parseInt(sqwSel[sqwI].contQty)
                    let fCalc = fRate * contQty
                    let fUSD = cvf2USD( this.exchangeRate, fr[rI].curr) * fRate * contQty
                    // let fUSD = cvf2USD( this.exchangeRate, fr[rI].curr)
                    console.log(`fUSD => ${fUSD}`)
                    fUSDSum += fUSD 
                    sqwItems.push({
                        id: sqwI+1,
                        contSize : sqwSel[sqwI].contSize,
                        contQty : contQty,
                        fRate : fRate,
                        fCurr : fr[rI].curr,
                        fCalc : fCalc,
                        fUSD : parseFloat(fUSD).toFixed(2), 
                        fUSD : fUSD, 
                        cargoKg : sqwSel[sqwI].cargoKg
                    })
                }
                frSum.push({
                    userId : this.userId,
                    compId: fr[rI].compId,
                    POL: fr[rI].POL,
                    POD: fr[rI].POD,
                    sctCode: fr[rI].sctCode,
                    fghtId: fr[rI].fghtId,
                    fghtCat: fr[rI].fghtCat,
                    agent: fr[rI].agent,
                    curr: 'USD', 
                    fUSD : parseFloat(fUSDSum.toFixed(2)),                  
                    fItems : sqwItems
                })
            }
            cb(frSum)
        },
        async surCalcLists(sur){
            let sc =[]
            for (let sI = 0; sI < sur.length; sI++) {
                let sqwSel = this.sqwSelection
                let surCalc = 0
                switch (sur[sI].rateBase) {
                    case "TEU":
                        for (let i = 0; i < sqwSel.length; i++) {
                            switch (sqwSel[i].contSize) {
                                case "L20":
                                //  let s = teuCont.L20 * sqwSel[i].contQty * parseInt(sur[sI].surRate)
                                //  surCalc += s
                                    surCalc += teuCont.L20 * sqwSel[i].contQty * parseInt(sur[sI].surRate)
                                    break;
                                case "L40":
                                    surCalc += teuCont.L40 * sqwSel[i].contQty * parseInt(sur[sI].surRate)
                                    break;
                                case 'L40HC':
                                    surCalc += teuCont.L40HC * sqwSel[i].contQty * parseInt(sur[sI].surRate)
                                    break;
                                case 'L20NOR':
                                    surCalc += teuCont.L20NOR * sqwSel[i].contQty * parseInt(sur[sI].surRate)
                                    break;
                                case 'L40NOR':
                                    surCalc += teuCont.L40NOR * sqwSel[i].contQty * parseInt(sur[sI].surRate)
                                    break;
                                case 'L45':
                                    surCalc += teuCont.L45 * sqwSel[i].contQty * parseInt(sur[sI].surRate)
                                    break;
                                case 'L45HC':
                                    surCalc += teuCont.L45HC * sqwSel[i].contQty * parseInt(sur[sI].surRate)
                                    break;
                                default:
                                    break;
                            }
                        }
                        break;
                    case "SIZE":
                        for (let i = 0; i < sqwSel.length; i++) {
                            switch (sqwSel[i].contSize) {
                                case 'L20':
                                    surCalc += sqwSel[i].contQty * parseInt(sur[sI].L20)
                                    break;
                                case 'L40':
                                    surCalc += sqwSel[i].contQty * parseInt(sur[sI].L40)
                                    break;
                                case 'L40HC':
                                    surCalc += sqwSel[i].contQty * parseInt(sur[sI].L40HC)
                                    break;
                                case 'L20NOR':
                                    surCalc += sqwSel[i].contQty * parseInt(sur[sI].L20NOR)
                                    break;
                                case 'L40NOR':
                                    surCalc += sqwSel[i].contQty * parseInt(sur[sI].L40NOR)
                                    break;
                                case 'L45':
                                    surCalc += sqwSel[i].contQty * parseInt(sur[sI].L45)
                                    break;
                                case 'L45HC':
                                    surCalc += sqwSel[i].contQty * parseInt(sur[sI].L45HC)
                                    break;
                                default:
                                    break;
                            }
                        }
                        break;
                    case "CONT":
                        for (let i = 0; i < sqwSel.length; i++) {
                            surCalc += sqwSel[i].contQty * parseInt(sur[sI].surRate)
                        }
                        break;
                    case "BL":
                        surCalc = parseInt(sur[sI].surRate )
                        break;
                    default:
                        break;
                }
                let surUSD = cvf2USD(this.exchangeRate, sur[sI].curr) * surCalc
                sc.push({
                    // userId : this.userId,
                    surCode : sur[sI].surCode,
                    agent: sur[sI].agent,
                    surRate : sur[sI].surRate,
                    rateBase : sur[sI].rateBase,
                    sCurr: sur[sI].curr, 
                    surCalc : surCalc,
                    surUSD : parseFloat(surUSD.toFixed(2)) ,    
                    L20 : sur[sI].L20, 
                    L40 : sur[sI].L40,
                    L40HC : sur[sI].L40HC       
                })  
            }
            return sc
        },
        async duoCharges(){
            let duoFghtCtcArr = ['2527677',this.compId] // [Conex's CompId , logist's CompId] 
            await getFghtRateByPOD( this.selectedPOD , this.shipDateReqr, duoFghtCtcArr,async(fRate)=>{
                if (fRate.length == 0) {
                    this.showAlertNoServicePOD = true
                } else {
                    const fghtRate = fRate.filter(i=>i.POL == this.selectedPOL)
                    if ( fghtRate.length == 0) {  //No Fght Rate then offer other POLs
                        let restP = []
                        fRate.filter((i)=>{
                            if (i.POL != this.selectedPOL) {
                                restP.push(i.POL)
                            }
                        })
                        let uniqueRestPOLsArr = restP.filter((item, index, self)=>{
                            return self.indexOf(item) === index
                        })
                        this.openModalRestPOLs(uniqueRestPOLsArr)
                    } else { 
                        // freight Sum
                        await this.fghtSum(fghtRate, async(fSum)=>{
                            this.showQuoteOptions = true
                            // console.log ('Freight Sum=>'+JSON.stringify(fSum , null, 2))
                            //Get surcharge
                            let polArr = ['ALL',this.selectedPOL]                      
                            let contTypeArr = ['ALL',this.contType]                     
                            let selPOLAgents = []
                            fghtRate.filter((i)=>selPOLAgents.push(i.agent))
                            let uniquePOLAgentArr = selPOLAgents.filter((item, index, self)=>{
                                return self.indexOf(item) === index
                            })
                            // await getSrvScpArrByCntry( this.selectedCntryPOD, async(sScp)=>{
                                // let srvScpArr =  sScp.split(',')
                                //     srvScpArr.push('ALL')
                                await getSrvScpArrByCntry( this.selectedCntryPOD, async(srvScpArr)=>{
                                    let portNameCode = await getPortNameCode(this.selectedPOD)
                                    srvScpArr.push('ALL', portNameCode)
                                    console.log(`srvScpArr=>${srvScpArr}`)
                                await getSurchargeByArrs(uniquePOLAgentArr, polArr, srvScpArr, contTypeArr,this.shipDateReqr, async(sur)=>{
                                    const scl = await this.surCalcLists(sur)
                                    // console.log ('Surcharge Sum =>'+JSON.stringify(scl , null, 2))
                                    this.itemsQO = fSum.map((fsI)=>{
                                        const agentSCL = scl.filter(s=>s.agent == fsI.agent)
                                        let surUSDSum = 0
                                        for (let scI = 0; scI < agentSCL.length; scI++) {
                                            // surCalcSum += agentSCL[scI].surCalc
                                            surUSDSum += agentSCL[scI].surUSD
                                        }
                                        return {
                                            surUSD : surUSDSum,
                                            surcharge : agentSCL,
                                            ...fsI
                                        }
                                    })
                                    this.totalRowsQO = fSum.length
                                    // console.log ('QO Items =>'+JSON.stringify(this.itemsQO , null, 2))
                                })
                            })
                        })
                    }
                }
            })
        },
        async refresh(){
            await getData( "QuoteForm", 'userId', this.userId, (res)=>{
                this.items = res
                this.totalRows = res.length
            })
            this.clearQuoteForm()
        },
        clearQuoteForm(){
            this.qfId = ''
            this.commodity =''
            this.hs6 =''
            this.dgGds = false
            this.contType =''
            this.contGrade =''
            this.sqwSelection = [
            { id: 1, contSize: '', contQty: 1, cargoKg: 100 } // Start with one select item
            ]            
            this.selectedPOL= ''
            this.shipDateReqr= ''
            this.selectedCntryPOD= ""
            this.selectedPOD= ''

        },
        async actUseAgain(item) {
            this.commodity = item.commodity
            this.hs6 = item.hs6
            this.dgGds = item.dgGDs
            this.contType = item.contType
            this.contGrade = item.contGrade
            this.sqwSelection = item.contSQW               
            this.selectedPOL= item.POL
            this.shipDateReqr= ''
            this.selectedCntryPOD= item.cntryPOD
            this.selectedPOD= item.POD  
        }, 
        actDelete(item) {
            this.$bvModal.msgBoxConfirm(this.$t('container.confirmDeleteMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await deleteItem( "QuoteForm", item.qfId)
                    await this.refresh()                   
                    this.$toasted.show( this.$t('container.deleted'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
                } else {
                    return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },  
        async openModalDetailsPOL(item, index, button) {
          await getData( 'Port' ,'id' , item.POL, (res)=>{
            this.portId = res[0].id
            this.pName = res[0].pName.trim()
            this.cntry = res[0].cntry
          })
          this.$root.$emit('bv::show::modal', "detailsPortModal" , button)
        },
        async openModalDetailsPOD(item, index, button) {
          await getData( 'Port' ,'id' , item.POD, (res)=>{
            this.portId = res[0].id
            this.pName = res[0].pName.trim()
            this.cntry = res[0].cntry
          })
          this.$root.$emit('bv::show::modal', "detailsPortModal" , button)
        },
        async openModalDetailsFght(item, index, button) {
            this.itemsFght = item.fItems
            this.$root.$emit('bv::show::modal', "detailsFghtModal" , button)
        },
        async openModalDetailsSur(item, index, button) {
            this.itemsSur = item.surcharge
            this.$root.$emit('bv::show::modal', "detailsSurModal" , button)
        },
        async openModalDetailsSurCode(item, index, button) {
          await getData( 'SurCode' ,'id' , item.surCode, (res)=>{
            this.selectedSurCode= res[0].id
            this.surDesc = res[0].surDesc
            this.remark = res[0].remark
          })
          this.$root.$emit('bv::show::modal', "detailsSurCodeModal" , button)
        },
        resetModalDetailsPort() {
            this.portId = ''
            this.pName = ''
            this.cntry = ''
        },
        resetModalDetailsFght() {
            this.itemsFght = []
            this.$root.$emit('bv::hide::modal', "detailsFghtModal")
        },
        resetModalDetailsSur() {
            this.itemsSur = []
            this.$root.$emit('bv::hide::modal', "detailsSurModal")
        },
        resetModalDetailsSurCode() {
            this.selectedSurCode = ''
            this.surDesc = ''
            this.remark = ''
        },
        async openModalRestPOLs(portArr) {
            await getPortListByPortArr( portArr, (res)=>{
                this.restPOLsOptions = res
            })
          this.$root.$emit('bv::show::modal', "restPOLsModal" )
        },     
        async clickUpdateSelRestPOLs(){
            this.selectedPOL = this.selectedRestPOL
            this.$root.$emit('bv::hide::modal', 'restPOLsModal')
        },   
        async clickCancelRestPOLs(){
            this.$root.$emit('bv::hide::modal', 'restPOLsModal')
        },   
        resetModalRestPOL(){
            this.selectedRestPOL = ''
        },
        rowSelected(item) {
            this.selectedQO = item
        },
        async selectBatchRowQO(){
            this.openModalAddInfo()
        },
        async openModalAddInfo() {
            await getData ('Company', 'compId', this.compId, (res)=>{
                this.shipper =res[0].compNameEng.toUpperCase()
                this.forwarder = res[0].compNameEng.toUpperCase()
            })
            await getData( 'Port' ,'id' , this.selectedPOL, (res)=>{
                this.POR =`${res[0].pName}-${res[0].id}`
            })
            await getData( 'Port' ,'id' , this.selectedPOD, (res)=>{
                this.DEL =`${res[0].pName}-${res[0].id}`
            })
          this.$root.$emit('bv::show::modal', "addInfoModal")
        },
        resetModalAddInfo(){
            this.shipper = ''
            this.forwarder = ''
            this.cargoOwner = ''
            this.POR = ''
            this.DEL = ''
            this.$root.$emit('bv::hide::modal', 'addInfoModal')
        },
        async clickCancelGetQuote(){
            this.refresh()
            this.$root.$emit('bv::hide::modal', 'addInfoModal')
            this.showQuoteOptions = false
        },           
        async gotoCustBookingTx(){
            try {
                this.$router.push('/eBooking/custBookingTx') 
            } catch (err){
                // Check if the error is the 'NavigationDuplicated' error
                if (err.name !== 'NavigationDuplicated') {
                // If it's another error, re-throw it
                // throw err;
                this.$toasted.show(err, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
                }
            }
            this.$root.$emit('bv::hide::modal', 'addInfoModal')
        },      
        async saveBookingTx(){         
            let msg = 'completed'
            if (this.shipper ==='') {
                msg = 'getQuote.shipperPh'
            } else if (this.forwarder ===''){
                msg = 'getQuote.forwarderPh'
            } else if (this.POR ===''){
                msg = 'getQuote.PORPh'
            } else if (this.DEL ===''){
                msg = 'getQuote.DELPh'
            } 
            if (msg === 'completed'){ 
                for (let i = 0; i < this.selectedQO.length; i++) {
                    const item = this.selectedQO[i];
                    let bTxId = this.$moment().format("YYMMDD")+'BT'+`${Math.floor(Math.random() * (90000 - 10000 + 1) + 10000)}`
                    let ts = Date.parse(new Date())
                    await saveWithId('BookingTx', bTxId, {
                        bTxId : bTxId,
                        qCompId: this.compId,
                        userId: this.userId,  
                        commodity : this.commodity,
                        dgGDs : this.dgGds,                       
                        hs6 : this.hs6, 
                        contSQW : this.sqwSelection,     
                        contType: this.contType,
                        contGrade: this.contGrade,  
                        sdrTS : Date.parse(this.shipDateReqr),            
                        cntryPOD : this.selectedCntryPOD,
                        shipper : this.shipper,
                        forwarder : this.forwarder,
                        cargoOwner : this.cargoOwner,
                        POR : this.POR,
                        DEL : this.DEL,
                        jbBTx:'waitCheck',
                        actCust:{
                            cancel:true, 
                            approve: false, 
                            reject:false,
                            editInfo : true,
                            msgr : true,
                            agentQ : false,
                            agentB : false,
                        },  
                        actAgent:{
                            accept: true, 
                            reject:true,
                            msgr : true,                        
                            preQInfo : true,
                            agentQ : false,
                            agentB : false,
                        },  
                        stepNo: 1,   
                        agentQ : '',
                        agentB : '',
                        timestamp: ts,
                        active: true,
                        ...item
                    }).then(async()=>{
                        await saveWithId('jbBTx', `${bTxId}-${ts}`, {
                            id : bTxId,
                            jbBTx : 'waitCheck',
                            timestamp : ts,
                        })
                    })
                }
                await this.gotoCustBookingTx()
            } else {
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
    },
}
</script>
<style scoped>
/* Basic styling for presentation */
#dynamic-form-app {
  font-family: Arial, sans-serif;
  padding: 15px;
  max-width: 2500px;
  margin: 0 auto;
  border: 1px solid #ccc;
  border-radius: 8px;
}

.select-group {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
}
.select-group-sqw {
  display: flex;
  align-items: flex-start;
  margin-bottom: 2px;
  padding: 2px;
  border: 1px solid #eee;
  border-radius: 4px;
}
label {
  flex-shrink: 0;
  margin-right: 10px;
  font-weight: bold;
}


.remove-button, .add-button {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
}

.remove-button {
  background-color: #f44336;
  color: white;
}

.add-button {
  background-color: #4CAF50;
  color: white;
  margin-top: 10px;
}

pre {
  background-color: #f4f4f4;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
}

hr {
    border: 0;
    border-top: 1px dashed #ccc;
    margin: 20px 0;
}
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }
 .gradient-wg {
   background: linear-gradient(135deg, white, rgb(0, 255, 136));
 }
 .gradient-wb {
   background: linear-gradient(135deg, white,rgb(0, 255, 251));
 }
 .gradient-wr {
   background: linear-gradient(135deg, white,rgb(255, 0, 149));
 }
.ui.button,
.dot.circle.icon{
    background-color: #138fc0;
    color : white
}
#mapReu {
    position:absolute;
    top:0;
    right:0;
    bottom: 0;
    left: 0;
    background: blue;
}

.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  /* text-transform: lowercase;
  font-variant: small-caps; */
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}
.gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }

 .switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
}.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* THIS IS WHERE YOU SET THE BACKGROUND COLOR WHEN OFF */
  background-color: #ccc; /* Example: Gray when off */
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

/* Change background color of the slider when checked (ON state) */
input:checked + .slider {
  /* THIS IS WHERE YOU SET THE BACKGROUND COLOR WHEN ON */
  background-color: #f33321; /* Example: Blue when on */
}

input:focus + .slider {
  box-shadow: 0 0 1px #f33321;
}

input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}
.divider {
    height: 5px;
    background-color: #0909f1;
    margin:5px
}

</style>
